export const getFirstLetter = (name: string): string => {
  return name.charAt(0);
};

export const getInitials = (name: string): (string | undefined)[] | string => {
  const result: (string | undefined)[] = [];

  if (name) {
    const fullName = name.split(" - ").pop(); // Extract full name
    const names = fullName!.split(" "); // Split full name into an array of names

    // // Get the first initial
    let firstInitial: string | undefined;
    if (names.length > 0) {
      firstInitial = names[0].charAt(0);
    }

    // Get the last initial if there are more than one name
    let lastInitial: string | undefined;
    if (names.length > 1) {
      lastInitial = names[names.length - 1].charAt(0);
    }
    result.push(firstInitial, names[0], lastInitial);
    return result;
  }
  return "";
};
